(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notice', {
            parent: 'app2',
            url: '/notice',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.notice'
            },
            views: {
                'content2': {
                    templateUrl: 'app/entities/notice/notice.html',
                    controller: 'NoticeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
